<template>
    <div class="main">
        <a-table :columns="columns" :dataSource="data" bordered>
            <template v-for="col in ['siteid', 'sitename', 'domain']" :slot="col" slot-scope="text, record, index">
                <div :key="col">
                    <a-input
                            v-if="record.editable"
                            style="margin: -5px 0"
                            :value="text"
                            @change="e => handleChange(e.target.value, record.key, col)"
                    />
                    <template v-else>{{text}}</template>
                </div>
            </template>
            <template slot="operation" slot-scope="text, record, index">
                <div class='editable-row-operations'>
                    <span v-if="record.editable">
                      <a @click="() => save(record.key)">保存</a>
                      <a-popconfirm title='确定保存吗 ?' @confirm="() => cancel(record.key)">
                        <a>取消</a>
                      </a-popconfirm>
                    </span>
                    <span v-else>
          <a @click="() => edit(record.key)">编辑</a>
        </span>
                </div>
            </template>
        </a-table>
    </div>
</template>

<script>
    const columns = [{
        title: '站点id',
        dataIndex: 'siteid',
        width: '25%',
        scopedSlots: { customRender: 'siteid' },
    }, {
        title: '站点名称',
        dataIndex: 'sitename',
        width: '15%',
        scopedSlots: { customRender: 'sitename' },
    }, {
        title: '绑定域名',
        dataIndex: 'domain',
        width: '40%',
        scopedSlots: { customRender: 'domain' },
    }, {
        title: '操作',
        dataIndex: 'operation',
        scopedSlots: { customRender: 'operation' },
    }]


    export default {
        name: "SiteList",
        data(){
          return{
              data:[],
              columns
          }
        },
        created(){
          this.getLists()
        },
        methods:{
            getLists(){
                this.$http.get('/api/content/sitelist',{limit:100})
                    .then(res=>{
                        if (res.data.state == 200){
                            // this.siteLists = res.data.data
                            for (let i = 0; i < res.data.data.length; i++) {
                                this.data.push({
                                    key: i.toString(),
                                    siteid: res.data.data[i].siteid,
                                    sitename: res.data.data[i].sitename,
                                    domain: res.data.data[i].domain,
                                })
                            }
                        }
                    })
            },
            handleChange (value, key, column) {
                const newData = [...this.data]
                const target = newData.filter(item => key === item.key)[0]
                if (target) {
                    target[column] = value
                    this.data = newData
                }
            },
            edit (key) {

                const newData = [...this.data]
                const target = newData.filter(item => key === item.key)[0]
                if (target) {
                    target.editable = true
                    this.data = newData
                }
            },
            save (key) {
                const newData = [...this.data]
                const target = newData.filter(item => key === item.key)[0]
                if (target) {
                    delete target.editable
                    this.data = newData
                    // this.cacheData = newData.map(item => ({ ...item }))
                }
            },
            cancel (key) {
                const newData = [...this.data]
                const target = newData.filter(item => key === item.key)[0]
                if (target) {
                    // Object.assign(target, this.cacheData.filter(item => key === item.key)[0])
                    delete target.editable
                    this.data = newData
                }
            },
        }
    }
</script>

<style scoped>
    .main {
        position: absolute;
        top:60px;
        left:20px;
        right:20px;
        /*bottom: 20px;*/
        overflow-y: auto;
        padding: 20px;
        background-color: #fff;
    }
    .editable-row-operations a {
        margin-right: 8px;
    }
</style>